let rootMounted = false;
let startupComplete = false;
let preloaderHidden = false;
let slowFallbackTimer: number | null = null;

const getPreloader = (): HTMLElement | null => document.getElementById("preloader");

const removePreloader = (): void => {
  const preloader = getPreloader();
  if (preloader?.parentElement) {
    preloader.parentElement.removeChild(preloader);
  }
};

const setSlowFallbackMessage = (): void => {
  if (slowFallbackTimer !== null || preloaderHidden) {
    return;
  }

  slowFallbackTimer = window.setTimeout(() => {
    if (preloaderHidden) {
      return;
    }

    const preloader = getPreloader();
    const message = preloader?.querySelector<HTMLElement>(".preloader-message");
    if (!message) {
      return;
    }

    const lang = (document.documentElement.lang || "en").toLowerCase();
    const selectedLanguage = lang.startsWith("fr") ? "fr" : "en";
    const slowMessages: Record<"en" | "fr", string> = {
      en: "Still loading, please wait",
      fr: "Chargement en cours, merci de patienter",
    };

    const baseText = slowMessages[selectedLanguage].replace(/\.*$/, "");
    message.setAttribute("data-base-text", baseText);
    message.textContent = baseText;
  }, 8000);
};

const tryHidePreloader = (): void => {
  if (preloaderHidden || !rootMounted || !startupComplete) {
    return;
  }

  preloaderHidden = true;

  const preloader = getPreloader();
  if (!preloader) {
    return;
  }

  const cleanup = (): void => removePreloader();

  preloader.classList.add("fade-out");
  preloader.addEventListener("transitionend", cleanup, { once: true });
  window.setTimeout(cleanup, 700);
};

export const signalRootMounted = (): void => {
  if (rootMounted) {
    return;
  }

  rootMounted = true;
  setSlowFallbackMessage();

  requestAnimationFrame(() => {
    requestAnimationFrame(tryHidePreloader);
  });
};

export const signalStartupComplete = (): void => {
  if (startupComplete) {
    return;
  }

  startupComplete = true;
  setSlowFallbackMessage();
  tryHidePreloader();
};
